import { render, staticRenderFns } from "./index_old.vue?vue&type=template&id=389b3ace&"
import script from "./index_old.vue?vue&type=script&lang=js&"
export * from "./index_old.vue?vue&type=script&lang=js&"
import style0 from "./index_old.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389b3ace')) {
      api.createRecord('389b3ace', component.options)
    } else {
      api.reload('389b3ace', component.options)
    }
    module.hot.accept("./index_old.vue?vue&type=template&id=389b3ace&", function () {
      api.rerender('389b3ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/index_old.vue"
export default component.exports